var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-textarea', {
    attrs: {
      "name": _vm.opts.key,
      "label": _vm.label,
      "suffix": _vm.opts.suffix || null,
      "placeholder": _vm.opts.placeholder || _vm.$t('globals.fillField') + ' ' + _vm.label,
      "error-messages": _vm.errorMessages
    },
    on: {
      "input": _vm.handleInput,
      "blur": function blur($event) {
        _vm.$v[_vm.opts.key].$touch();
      }
    },
    scopedSlots: _vm._u([_vm.description ? {
      key: "append",
      fn: function fn() {
        return [_c('v-tooltip', {
          attrs: {
            "top": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function fn(_ref) {
              var on = _ref.on;
              return [_c('v-icon', _vm._g({}, on), [_vm._v(" mdi-information-outline ")])];
            }
          }], null, false, 3375908706)
        }, [_vm._v(" " + _vm._s(_vm.description) + " ")])];
      },
      proxy: true
    } : null], null, true),
    model: {
      value: _vm.$data[_vm.opts.key],
      callback: function callback($$v) {
        _vm.$set(_vm.$data, _vm.opts.key, $$v);
      },
      expression: "$data[opts.key]"
    }
  });

}
var staticRenderFns = []

export { render, staticRenderFns }